import _extends from '@babel/runtime/helpers/esm/extends';
import { forwardRef, useEffect, createElement } from 'react';
import { useThree, useFrame } from 'react-three-fiber';
import useEffectfulState from '../helpers/useEffectfulState.js';
import { MapControls as MapControls$1 } from 'three/examples/jsm/controls/OrbitControls';

const MapControls = /*#__PURE__*/forwardRef((props = {
  enableDamping: true
}, ref) => {
  const {
    camera,
    gl,
    invalidate
  } = useThree();
  const controls = useEffectfulState(() => new MapControls$1(camera, gl.domElement), [camera, gl], ref);
  useFrame(() => controls == null ? void 0 : controls.update());
  useEffect(() => {
    controls == null ? void 0 : controls.addEventListener == null ? void 0 : controls.addEventListener('change', invalidate);
    return () => controls == null ? void 0 : controls.removeEventListener == null ? void 0 : controls.removeEventListener('change', invalidate);
  }, [controls, invalidate]);
  return controls ? /*#__PURE__*/createElement("primitive", _extends({
    dispose: undefined,
    object: controls,
    enableDamping: true
  }, props)) : null;
});

export { MapControls };
